export default __webpack_public_path__ + "static/sx-fc6fe7c577841cf6f9dfc6bae121e401.svg";